import { type AnyObject, type ObjectSchema } from 'yup';
import { type ISerializedFormSectionValue } from './ISerializedFormSectionValue.ts';
import {
  type ISerializedFormValue,
  serializeFormValues,
} from './serializeFormValues.tsx';

/**
 * Serializza e mappa i valori delle sezioni in un formato compatibile con l'API
 */
export function serializeFormSectionsValues(props: {
  validationSchema: ObjectSchema<AnyObject>;
  values: Record<string, any>;
  /** Permette di applicare una trasnform ulteriore ai dati serializzati di una sezione */
  transform?: (value: ISerializedFormValue) => ISerializedFormValue;
}): ISerializedFormSectionValue[] {
  const { validationSchema, values, transform } = props;

  const serializedValues = serializeFormValues(validationSchema, values);

  return (
    serializedValues.values?.map(v => ({
      // Non dovrebbe mai essere undefined, ma per sicurezza e per evitare errori di tipi lo gestiamo
      idSezione: v?.name ?? '<undefined>',
      valori: transform?.(v) ?? v,
    })) ?? []
  );
}
